import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { FileStatus } from '../local-import.enum';
import { ImportFileInfo } from '../local-import.interface';
import { getStatusClass } from '../local-import.utils';
import { copyTextToClipboard } from '../../../shared/browser.utils';

@Component({
  host: { 'test-id': 'local-import-table-file-row' },
  selector: 'local-import-table-file-row',
  styleUrls: ['./local-import-table-file-row.component.scss'],
  templateUrl: './local-import-table-file-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalImportTableFileRow implements OnChanges {
  @Input() file: ImportFileInfo;
  @Input() completedPartsSize: number;
  @Input() status: FileStatus;

  @Output() readonly cancel = new EventEmitter<ImportFileInfo>();
  @Output() readonly retry = new EventEmitter<ImportFileInfo>();

  protected readonly getStatusClass = getStatusClass;
  protected readonly statusEnum = FileStatus;
  protected name = '';
  protected progress = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.file?.currentValue) {
      this.name = this._getName();
    }

    if (changes.completedPartsSize?.currentValue) {
      this.progress = this.getLoadingProgress();
    }
  }

  protected getLoadingProgress(): number {
    if (!this.completedPartsSize) {
      return 0;
    }

    return Math.round(this.completedPartsSize / this.file.size * 100);
  }

  private _getName(): string {
    const splitFileName = this.file.fileName.split('/');
    return splitFileName[splitFileName.length - 1];
  }

  copyErrorToClipboard(file: ImportFileInfo): void {
    copyTextToClipboard(file.failureReason)
  }
}
